exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-rating {\n  display: inline-block;\n  font-size: 1.5em;\n  color: #d3d3d3; /* Couleur des étoiles vides */\n  position: relative;\n}\n\n.star-rating .filled-stars {\n  color: #f5c518; /* Couleur des étoiles remplies */\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  white-space: nowrap;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/offer/offer-table/offer-table.component.css
// module id = ../../../../../src/app/_components/offer/offer-table/offer-table.component.css
// module chunks = main